<div class="min-h-screen flex items-center justify-center bg-mist p-6">
	<div class="w-full max-w-md">
		<!-- Logo -->
		<div class="text-center mb-8">
			<app-logo [variant]="'dark'" [size]="'sm'" [isLink]="true"></app-logo>
		</div>

		<!-- Card -->
		<div class="bg-white rounded-2xl shadow-xl border border-charcoal/10 p-8">
			<!-- Back to Login -->
			<a routerLink="/login" class="group inline-flex items-center gap-2 text-charcoal/60 hover:text-primary transition-all duration-300 mb-6">
				<svg class="w-4 h-4 transition-transform duration-300 group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
				</svg>
				<span class="text-sm font-medium">Back to Login</span>
			</a>

			<!-- Icon -->
			<div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6">
				<svg class="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
				</svg>
			</div>

			<h2 class="text-2xl font-bold text-charcoal mb-2">Forgot Password?</h2>
			<p class="text-charcoal/60 text-sm mb-6">Enter your email address and we'll send you a link to reset your password.</p>

			<!-- Success Message -->
			@if (showSuccess()) {
			<div class="mb-6 p-4 bg-green-50 border-l-4 border-green-500 rounded-lg">
				<div class="flex items-start gap-3">
					<svg class="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
					</svg>
					<p class="text-sm text-green-700">{{ successMessage() }}</p>
				</div>
			</div>
			}

			<!-- Error Message -->
			@if (showError()) {
			<div class="mb-6 p-4 bg-red-50 border-l-4 border-primary rounded-lg">
				<p class="text-sm text-charcoal font-medium">{{ errorMessage() }}</p>
			</div>
			}

			<!-- Form -->
			<form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" class="space-y-5">
				<div>
					<label for="email" class="block text-sm font-semibold text-charcoal mb-2">Email Address</label>
					<input
						type="email"
						id="email"
						formControlName="email"
						[class.border-red-500]="isFieldInvalid('email')"
						class="w-full px-4 py-3 bg-white border-2 border-charcoal/20 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all outline-none text-charcoal placeholder-charcoal/40"
						placeholder="you@example.com"
					/>
					@if (isFieldInvalid('email')) {
					<p class="mt-1.5 text-xs text-red-500">Please enter a valid email address</p>
					}
				</div>

				<button
					type="submit"
					[disabled]="isSubmitting()"
					class="w-full bg-primary hover:bg-primary-75 text-mist font-semibold py-3.5 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center gap-2">
					@if (isSubmitting()) {
					<svg class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
						<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
						<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
					</svg>
					<span>Sending...</span>
					} @else {
					<span>Send Reset Link</span>
					}
				</button>
			</form>
		</div>
	</div>
</div>
